import z from 'zod';

export const TERMS_AND_CONDITIONS_FORM_SCHEMA = z.object({
  termsAccepted: z.boolean().refine((val) => val === true, {
    message: 'Required field',
  }),
  privacyAccepted: z.boolean().refine((val) => val === true, {
    message: 'Required field',
  }),
});
